import {Platform} from 'react-native';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';

export type NavHandlerConfig = {
  nativeRoute: AppRoutes;
  webStack: AppRoutes[];
  webTarget: AppRoutes;
  webParams?: unknown;
};

export function makeNavHandler({
  nativeRoute,
  webStack,
  webTarget,
  webParams,
}: NavHandlerConfig) {
  return () => {
    if (Platform.OS === 'web') {
      NavActions.nestedPush(webStack, webTarget, webParams);
    } else {
      NavActions.navigate(nativeRoute);
    }
  };
}
